<template>
  <div>
    <!-- 导航栏 -->
    <!-- <nav-header :href="this.href"></nav-header> -->

    <div class="container">
      <!-- 纠纷处理 -->
      <div class="ag-con">
        <h3>交易纠纷处理</h3>
        <div class="t-con">
          <p>
            北京画娱天下科技有限公司
            （以下简称画娱网）在此特别提醒用户在注册、登录本站前请务必仔细阅读本《纠纷处理方式》（未成年人应当在其法定监护人陪同下阅读）中的各个条款，以确保您在享受本站服务的同时维护自身合法权益：
          </p>
        </div>

        <h3>1.用户之间纠纷处理方式</h3>
        <div class="t-con">
          <p>
            （1）画娱网仅作为本站的运营商，如若本站用户之间发生纠纷且无法协商一致的，可向国家相关行政机关或司法机关寻求解决包括但不限于向公安机关报案、申请仲裁或向人民法院提起诉讼等。画娱网将会为实名注册用户提供必要的协助和支持，并根据有关行政机关和司法机关的要求承担一定的举证责任或采取必要措施。
          </p>
        </div>

        <h3></h3>
        <div class="t-con">
          <p>
            （2）本站用户之间发生纠纷的，也可画娱网客服人员投诉并举证。用户需提供与其账号注册信息一致的个人有效身份证件、必要的国家行政或司法机关文件和其他画娱网要求提供的相关证据。经画娱网审核确认后，可以给予必要的协助和支持。
          </p>
        </div>

        <h3>用户与画娱网之间纠纷处理方式</h3>
        <div class="t-con">
          <p>
            （1）如本站用户对画娱网的服务有任何异议的，可以向画娱网的客服人员投诉并举证。查证属实的，画娱网将立即更正并按照现行法律规定给予用户必要的补偿。
          </p>
        </div>

        <h3></h3>
        <div class="t-con">
          <p>
            （2）如本网站用户对画娱网的服务有任何异议的，也可以向双方约定的画娱网公司所在地人民法院提起诉讼。
            抵制不良音乐 拒绝盗版音乐 注意自我保护 谨防受骗上当 适度音乐益脑
            沉迷音乐伤身 合理安排时间 享受健康生活
          </p>
        </div>

        <h3></h3>
        <div class="t-con">
          <p></p>
        </div>

        <h4>纠纷处理人：黎超文</h4>
        <h4>电话：13512718426</h4>

        <h4>地址：北京市海淀区知春路6号(锦秋国际大厦)4层A03</h4>
      </div>
    </div>
  </div>
</template>

<script>
// import NavHeader from "./../components/NavHeader";
export default {
  name: "ag",
  components: {
    // NavHeader,
  },
  data() {
    return {
      href: "index.html",
    };
  },
  methods() {
    document.title = " 画娱网";
  },
};
</script>
<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";

.container {
  .ag-con {
    margin: 30px auto;
    // 文字容器
    .t-con {
      margin: 30px auto;
      font-size: 14px;
      line-height: 40px;
      text-align: left;
      p {
        margin: 10px auto;
      }
    }
  }
}
</style>
